import {dataPostRequest, getBaseUrl, getRequest} from "../../utils/request";


/**
 * 推进任务进度
 * @returns {AxiosPromise}
 * @param params
 */
export const pushTask = (params) => {
  return dataPostRequest('/task/push', params);
}

/**
 * 获得任务清单
 * @param params
 * @returns {AxiosPromise}
 */
export const listTask = (params) => {
  return dataPostRequest('/task/list', params);
}

export const listTaskLog = (params) => {
  return dataPostRequest('/task/log', params);
}

export const taskPublish = (params) => {
  return dataPostRequest('/task/publish', params);
}

export const deleteTask = (params) => {
  return dataPostRequest('/task/delete', params);
}

export const getUploadUrl = () => {
  return getBaseUrl() + `/file/upload`;
}

export const getErrorTask = (data) => {
  return dataPostRequest('/task/error/',data);
}

export const ignoreErrorTask = (data) => {
  return dataPostRequest('/task/storeHouse/scan/ignoreError',data);
}

export const updateErrorTask = (data) =>{
  return dataPostRequest('/task/error/updateTask', data);
}

export const updateTaskSetting = (data) =>{
  return dataPostRequest('/task/setting/update',data);
}



// WEBPACK FOOTER //
// ./src/api/task/task.js